import { Link, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import styled from 'styled-components';

import Modal from '../organisms/Modal';

const Attribution = styled.div`
    width: 100%;
    text-align: center;
    background-color: #f8f9fa;
    color: #aaa;
    padding: 0px 0 24px 0px;

    &:before {
        max-width: 1200px;
        margin: 0 auto;
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: #ccc;
        margin-bottom: 24px;
        border-radius: 2px;

        @media (max-width: 480px) {
            max-width: 90%;
        }
    }
`;

const FooterContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #f8f9fa;
    border-top: 1px solid #ddd;
    padding: 24px 0;
    margin-top: auto;

    @media (min-width: 768px) {
        padding: 32px 0;
    }
`;

const FooterContent = styled.div`
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: flex-start;
    padding: 0 20px;
    gap: 32px;

    @media (max-width: 480px) {
        flex-direction: column;
    }
`;

const FooterColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    min-width: 20vw;
    width: 100%;

    @media (max-width: 768px) {
        min-width: 30vw;
    }

    @media (max-width: 480px) {
        min-width: 100%;
    }
`;

const LinksColumn = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 100%;

    @media (max-width: 480px) {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        column-gap: 20px;
        row-gap: 10px;
    }

    & > a {
        margin-bottom: 10px;
        text-decoration: none;
        color: #333;
        font-size: 14px;
        transition: all 0.2s ease-in-out;
        width: fit-content;

        &:hover {
            color: rgb(86, 5, 13);
            transform: translateY(-2px);
            text-shadow: 0px 2px 5px rgba(20, 20, 20, 0.5);
        }

        @media (max-width: 480px) {
            font-size: 16px;
            background-color: #fff;
            padding: 10px 20px;
            border-radius: 5px;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        }
    }
`;


const Footer = (props) => {
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const location = useLocation();

    const openContactModal = (e) => {
        e.preventDefault();
        setContactModalOpen(true);
    }
    const closeContactModal = () => { setContactModalOpen(false); }

    return (
        <>
            <FooterContainer>
                <FooterContent>
                    <FooterColumn>
                        <LinksColumn>
                            {location.pathname !== '/' && <Link to="/">Home</Link>}
                            <Link target="_blank" to='https://www.zola.com/registry/simronandsunny'>Registry</Link>
                            <Link onClick={openContactModal}>Contact</Link>
                        </LinksColumn>
                    </FooterColumn>
                </FooterContent>
            </FooterContainer>
            <Attribution>Made by <a href="https://sunnysingh.tech/" target="_blank" rel="noreferrer">Sunny</a> ☀️</Attribution>

            <Modal isOpen={contactModalOpen} onClose={closeContactModal}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h3 style={{ marginTop: 0, marginBottom: 0, fontSize: 22 }}>Contact</h3>
                    <button onClick={closeContactModal} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer' }}>✖</button>
                </div>
                <hr />
                <ul>
                    <li style={{ marginBottom: 16 }}>Bikash Dhali: <a href="tel:8473408257">847-340-8257</a></li>
                    <li>Rina Bala: <a href="tel:8473479240">847-347-9240</a></li>
                </ul>
            </Modal>
        </>
    );
}

export default Footer;